<template>
    <div>
        <a-page-header v-if="!editing" style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Sesi" @back="back">
            <br>
            <a-card type="inner" size="small" bordered>
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Kelas">
                                <strong>{{ this.classes.name }}</strong>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="formData" ref="ruleForm" :rules="rules">

                    <a-divider dashed orientation="left">Sesi Kelas</a-divider>

                    <a-form-model-item label="Kategori" prop="parent_id">
                        <a-select
                            placeholder="Pilih kategori"
                            @select="handleChange"
                            v-model="formData.parent_id"
                        >
                            <a-spin v-if="preloadCat" slot="notFoundContent" size="small" />
                            <a-select-option
                                v-for="category in categories"
                                :key="category.id"
                                :value="category.id"
                            >
                                {{ category.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Materi" prop="material_id">
                        <a-select
                            placeholder="Pilih materi"
                            @select="handleChangeMaterial"
                            v-model="formData.material_id"
                        >
                            <a-spin v-if="preloadMat" slot="notFoundContent" size="small" />
                            <a-select-option
                                v-for="material in materials"
                                :key="material.id"
                                :value="material.id"
                            >
                                {{ material.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Nama Sesi" prop="name">
                        <a-input placeholder="Nama Sesi" v-model="formData.name">
                            <a-icon
                                slot="prefix"
                                type="highlight"
                                style="color: rgba(0, 0, 0, 0.25)"
                            />
                        </a-input>
                    </a-form-model-item>

                    <a-form-model-item label="Inspirator" prop="inspirator_id">
                        <a-select placeholder="Pilih Inspirator" v-model="formData.inspirator_id">
                            <a-select-option
                                v-for="inspired in inspireds"
                                :key="inspired.hash"
                                :value="inspired.hash"
                            >
                                {{ inspired.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Time start" props="session_time_start" required>
                        <a-date-picker
                            placeholder="Pilih Waktu"
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                            format="YYYY-MM-DD HH:mm:ss"
                            @change="onSessStartDateChange"
                            v-model="formData.session_time_start"
                        />
                    </a-form-model-item>

                    <a-form-model-item label="Time end" props="session_time_end" required>
                        <a-date-picker
                            placeholder="Pilih Waktu"
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                            format="YYYY-MM-DD HH:mm:ss"
                            @change="onSessEndDateChange"
                            v-model="formData.session_time_end"
                        />
                    </a-form-model-item>

                    <template>
                        <a-divider dashed orientation="left">Sesi Ujian</a-divider>

                        <a-form-model-item label="Ujian" props="exam_id" required>
                            <a-select placeholder="Pilih Ujian" v-model="formData.exam_id">
                                <a-spin v-if="preloadExam" slot="notFoundContent" size="small" />
                                <a-select-option
                                    v-for="exam in exams"
                                    :key="exam.id"
                                    :value="exam.id"
                                >
                                    {{ exam.description }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>

                        <a-form-model-item label="Time start" props="exam_time_start" required>
                            <a-date-picker
                                placeholder="Pilih Waktu"
                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                format="YYYY-MM-DD HH:mm:ss"
                                @change="onExamStartDateChange"
                                v-model="formData.exam_time_start"
                            />
                        </a-form-model-item>

                        <a-form-model-item label="Durasi" props="exam_duration" required>
                            <a-row type="flex" :gutter="8">
                                <a-col>
                                    <a-input-number :min="0" placeholder="Durasi" v-model="formData.exam_duration">
                                        <a-icon
                                            slot="prefix"
                                            type="clock-circle"
                                            style="color: rgba(0, 0, 0, 0.25)"
                                        />
                                    </a-input-number>
                                </a-col>
                                <a-col align="left">
                                    Menit
                                </a-col>
                            </a-row>
                        </a-form-model-item>

                        <a-form-model-item label="Remedial Time start" props="remid_time_start" required>
                            <a-date-picker
                                placeholder="Pilih Waktu"
                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                format="YYYY-MM-DD HH:mm:ss"
                                @change="onRemidStartDateChange"
                                v-model="formData.remid_time_start"
                            />
                        </a-form-model-item>

                        <a-form-model-item props="class_id">
                            <a-input v-model="formData.class_id" type="hidden"></a-input>
                        </a-form-model-item>
                    </template>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        v-if="editing"
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: {
        classes: {
            type: Object,
        },
        session_id: {
            type: String,
            default: ""
        },
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
            this.getInspired()
        }else{
            this.formData.class_id = this.classes.id
            this.getMaterial('category')
            this.getInspired()
        }
    },
    computed: {
        editing() {
            return this.session_id !== ""
        },
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 14 },
            rules: {
                parent_id: [{ required: true, message: 'Pilih kategori', trigger: 'change' },],
                material_id: [{ required: true, message: 'Pilih materi', trigger: 'change' },],
                name: [{ required: true, message: 'Nama sesi wajib diisi', trigger: 'blur' },],
                inspirator_id: [{ required: true, message: 'Pilih inpirator', trigger: 'change' },],
                session_time_start: [{ required: true, message: 'Pilih jam dimulai sesi', trigger: 'change' },],
                session_time_end: [{ required: true, message: 'Pilih jam berakhir sesi', trigger: 'change' },],
                exam_id: [{ required: true, message: 'Pilih ujian', trigger: 'change' },],
                exam_time_start: [{ required: true, message: 'Pilih jam ujian', trigger: 'change' },],
                exam_duration: [{ required: true, message: 'Durasi jam wajib diisi', trigger: 'change' },],
                remid_time_start: [{ required: true, message: 'Pilih jam remidi', trigger: 'change' },],
            },
            form: this.$form.createForm(this),
            formData: {
                material: {}
            },
            preload: false,
            processing: false,
            item: {
                category_id: ''
            },
            categories: [],
            materials: [],
            exams: [],
            inspireds: [],
            preloadCat: false,
            preloadMat: false,
            preloadExam: false,
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(this.routeUri('api.classical-session.show', { session: this.session_id }))
                .then(res => {
                    this.formData = res.data.session
                    this.formData.parent_id = this.formData.material.parent_id
                    this.getMaterial('category', this.formData.material.parent_id)
                    this.getMaterial('material', this.formData.material_id)
                    this.getExams(this.formData.material_id)
                })
                .finally(() => (this.preload = false))
        },
        getMaterial(cat_type, id) {
            
            if(cat_type == 'category'){
                this.preloadCat = true
            }else{
                this.preloadMat = true
            }

            let params = {
                type: cat_type
            }

            this.$http
                .get(this.routeUri('api.material') + '?' + this.$qs.stringify(params))
                .then(res => {
                    if(cat_type == 'category'){
                        this.categories = res.data.materials
                    }else{
                        this.materials = res.data.materials
                    }
                })
                .finally(() => {
                    this.preloadCat = false
                    this.preloadMat = false
                })
        },
        getExams(material_id) {
            this.preloadExam = true
            this.$http.get(this.routeUri('api.material-exam', { material: material_id }))
                .then((r) => this.exams = r.data.material_exams)
                .catch((error) => this.handleXhrError(error))
                .finally(() => this.preloadExam = false)
        },
        getInspired() {
            let params = {
                role: 'inspirator',
                env: 'classical'
            }

            this.$http.get(this.routeUri('api.users') + '?' + this.$qs.stringify(params))
                .then((r) => this.inspireds = r.data.users)
                .catch((error) => this.handleXhrError(error))
                .finally(() => this.preload = false)
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.processing = true

                    let promise

                    if (this.editing) {
                        promise = this.$http.put(
                            this.routeUri('api.classical-session.update', { session: this.session_id }), this.formData
                        )
                    } else {
                        promise = this.$http.post(
                            this.routeUri('api.classical-session.store'), this.formData
                        )
                    }

                    promise
                        .then(response => this.handleSuccessResponse(response.data))
                        .catch(error => this.handleResponseError(error.response.data))
                        .finally(() => (this.processing = false))
                }else{
                    return false
                }
            })
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })
            setTimeout(() => window.location.href = this.routeUri('admin.classical.class.sessions') , 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        back() {
          window.location.href = this.routeUri('admin.classical.class.sessions')
        },
        handleChange(value) {
            this.getMaterial('material', value)
        },
        handleChangeMaterial(value) {
            this.getExams(value)
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        onSessStartDateChange(date, dateString) {
            this.formData.session_time_start = dateString
        },
        onSessEndDateChange(date, dateString) {
            this.formData.session_time_end = dateString
        },
        onExamStartDateChange(date, dateString) {
            this.formData.exam_time_start = dateString
        },
        onRemidStartDateChange(date, dateString) {
            this.formData.remid_time_start = dateString
        },
    }
}
</script>
